import useSWR from "swr";

import { simpleFetcher } from "../fetcher";

interface DiffSummary {
  createdAt: string;
  updatedAt: string;
  summary: string;
}

export const useDiffSummary = (documentArtifactId: number | undefined) => {
  return useSWR<DiffSummary, Error>(
    documentArtifactId
      ? `/api/v2/document-artifacts/${documentArtifactId}/diff-summary`
      : null,
    simpleFetcher,
  );
};
